<template>
    <div class="login-container">
        <el-dialog :visible.sync="dialogVisible" width="360px" :modal-append-to-body="false" :before-close="handleClose" :close-on-click-modal="false" :custom-class="'login-dialog'">
               <!-- 登录，注册 -->
            <div class="login">
                <!-- <div class="logo">
                    <img src="../assets/AIGC.png" alt="">
                </div> -->
                <div class="login-box">
                    <div class="login-title">
                        <span class="phone_login">{{ btnStatus ==='login'?'手机登录':'手机注册' }}</span>
                        <span class="register" @click="register">{{  btnStatus=='login'?'立即注册':'立即登录' }}</span>
                    </div>
                    <div class="login-input">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                            <el-form-item  prop="phone">
                                <el-input v-model="ruleForm.phone" :placeholder="btnStatus=='login'?'请输入手机号':'请输入注册手机号码'"></el-input>
                            </el-form-item>
                            <el-form-item  prop="password">
                                <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码"></el-input>
                            </el-form-item>
                            <el-form-item  prop="checkPass" v-if="btnStatus!='login'">
                                <el-input type="password" v-model="ruleForm.checkPass" placeholder="请再次输入密码"></el-input>
                            </el-form-item>
                            <el-form-item  prop="code" v-if="btnStatus!='login'">
                                <el-input class="form-item-code" v-model="ruleForm.code" placeholder="验证码">
                                    <template slot="append">
                                        <el-button class="send-code"  @click="sendCode" :disabled="!canSendCode">
                                            {{ btnText }}
                                        </el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <!-- <el-form-item prop="type" class="agreement">
                                <el-checkbox-group v-model="ruleForm.type">
                                    <el-checkbox name="type">
                                        <span>我已阅读并同意 <a href="" style="color:rgba(0, 120, 239, 1)">用户协议</a> 和 <a href="" style="color:rgba(0, 120, 239, 1)">隐私条款</a></span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item> -->
                            <el-form-item>
                                <el-button class="login-btn" type="primary" @click="submitForm('ruleForm')">{{ btnStatus=='login'?'登录':'注册' }}</el-button>
                            </el-form-item>
                            <div class="forget-password"><span @click="forgetPassword">忘记密码？</span></div>
                        </el-form>
                    </div>
                </div>
            </div>
        </el-dialog>
        <verify-modal ref="verifyModal" @success="verifyCaliback" :id="'slide-bar'"></verify-modal>
        <!-- <apply-trial></apply-trial> -->
    </div>
</template>
<script>
import verifyModal from '@/components/VerifyModal'
import applyTrial from '@/components/ApplyTrial'
import Api from "@/api/index.js";
import { setUserName, setUserToken } from '../utils/user';
export default {
    components:{
        verifyModal,
        applyTrial
    },
    data(){
        const validatePass = (rule, value, callback) => {
            if (!this.validPass(value)) {
                callback(new Error('密码要包含大小字母数字特殊字符，长度10-20'));
            } else {
                callback();
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return{
            btnStatus:'login',
            dialogVisible:false,
            ruleForm:{
                phone:'',
                password:'',
                checkPass: '',
                code:'',
                type:[]
            },
            rules:{
                phone:[
                    {required:true,message:'请输入手机号',trigger:'blur'},
                    {min:11,max:11,message:'请输入11位手机号',trigger:'blur'}
                ],
                password:[
                    {required:true,message:'请输入密码',trigger:'blur'},
                    {validator: validatePass, trigger: 'blur'}
                ],
                checkPass:[
                    { validator: validatePass2, trigger: 'blur' }
                ],
                code:[
                    {required:true,message:'请输入验证码',trigger:'blur'},
                    {min:6,max:6,message:'请输入6位验证码',trigger:'blur'}
                ],
                // type:[
                //     {type:'array',required:true,message:'请同意用户协议和隐私条款',trigger:'change'}
                // ]
            },
            btnText:'发送验证码',
            disabled:false,
            timer:null,
            count:60
        }
    },
    methods:{
        //显示弹窗
        showDialog(){
            this.dialogVisible = true
        },
        register(){
            this.btnStatus = this.btnStatus === 'login'?'register':'login'
        },
        sendCode(){
            //判断是否输入手机号
            if(!this.ruleForm.phone){
                this.$message({
                    type:'warning',
                    message:'请输入手机号'
                })
                return
            }
            //是否输入密码
            if(this.btnStatus === 'login' && !this.ruleForm.password){
                this.$message({
                    type:'warning',
                    message:'请输入密码'
                })
                return
            }
            // if(this.disabled){
            //     return
            // }
            if(this.canSendCode) {
                this.$refs.verifyModal.invokeModal()
            }
        },
        verifyCaliback(info){
          
            if(this.btnStatus === 'login'){
                let params={
                mobile:this.ruleForm.phone,
                password:this.ruleForm.password,
                ...info
                }
                Api.sendCode(params).then(res=>{
                    if(res.code === 200){
                        this.$message({
                            type:'success',
                            message:'验证码发送成功'
                        })
                        this.countDown()
                    }
                }).catch(err=>{
                    this.$message({
                            type:'error',
                            message:err.msg
                        })
                })
            }else{
                let params={
                    mobile:this.ruleForm.phone,
                    ...info
                }
                Api.registerSendCode(params).then(res=>{
                    if(res.code === 200){
                        this.$message({
                            type:'success',
                            message:'验证码发送成功'
                        })
                        this.countDown()
                    }
                }).catch(err=>{
                    this.$message({
                            type:'error',
                            message:err.msg
                        })
                })
            }
        
      
        },
        countDown(){
            this.timer = setInterval(()=>{
                if(this.count === 0){
                    clearInterval(this.timer)
                    this.timer = null
                    this.btnText = '发送验证码'
                    this.disabled = false
                    this.count = 60
                }else{
                    this.count--
                    this.btnText = `${this.count}秒后重发`
                    this.disabled = true

                }
            },1000)
        },
        //登录
        submitForm(formName){
            this.$refs[formName].validate((valid)=>{
                if(valid){
                    if(this.btnStatus === 'login'){
                        let params={
                            mobile:this.ruleForm.phone,
                            password:this.ruleForm.password,
                        }
                        Api.login(params).then(res=>{
                            if(res.code === 200){
                                this.$message({
                                    type:'success',
                                    message:'登录成功'
                                })
                                localStorage.setItem("timestamp", new Date().getTime());
                                setUserToken(res.data.token)
                                setUserName(res.data.nickname)
                                this.$emit('login-success', res.data)
                                this.handleClose()
                            }
                        }).catch(err=>{
                            this.$message({
                                type:'error',
                                message:err.msg
                            })
                        })
                    }else{
                        let params={
                            mobile:this.ruleForm.phone,
                            password:this.ruleForm.password,
                            code:this.ruleForm.code
                        }
                        Api.register(params).then(res=>{
                            if(res.code === 200){
                                this.$message({
                                    type:'success',
                                    message:'注册成功'
                                })
                                this.btnStatus = 'login'
                                this.btnText = '发送验证码'
                                localStorage.setItem("timestamp", new Date().getTime());
                                setUserToken(res.data.token)
                                setUserName(res.data.nickname)
                                this.$emit('login-success', res.data)
                                this.handleClose()
                            }
                        }).catch(err=>{
                            this.$message({
                                type:'error',
                                message:err.msg
                            })
                        })
                    }
                }else{
                    return false
                }
            })
        },
        handleClose() {
            this.$refs['ruleForm'].resetFields()
            this.dialogVisible = false
        },
        validPhone(phone) {
            return phone.length === 11
        },
        forgetPassword() {
            this.handleClose()
            this.$emit('change-password')
        },
        // 密码-正则校验
        validPass(value) {
            if((/[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/g.test(value))&&(/\d+/g.test(value))&&(/[A-Z]+/g.test(value))&&(/[a-z]+/g.test(value))&&value.length>=10&&value.length<=20 ){
                return true
            } else {
                return false
            }
        }
    },
    computed: {
        // 发送验证码按钮是否可以点击
        canSendCode() {
            // 已经在倒计时不能点击
            if(this.timer) return false
            // 登录表单
            if(this.btnStatus == 'login') {
                if(this.validPhone(this.ruleForm.phone) && this.validPass(this.ruleForm.password)) {
                    return true
                } else {
                    return false
                }
            } else {
                if(this.validPhone(this.ruleForm.phone) && this.validPass(this.ruleForm.password) && this.ruleForm.password == this.ruleForm.checkPass) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
}
</script>
<style lang="scss">
 .mobile{
    .login-dialog{
        transform: scale(2.5);
        margin-top: 40vh !important;
    }
}
</style>
<style lang="scss" scoped>

.login-container{
 
    
    /deep/ .el-dialog__header{
        // padding:0;
    }
    /deep/ .el-dialog__body{
        padding:0;

    }
  
    // margin:0 auto;
    .login{
        

        width: 360px;
        // height: 450px;
        background: #FFFFFF;
        border-radius: 16px;
        padding: 44px 32px 10px 32px;
        .logo{
            width: 142px;
            height: 38px;
            margin: 0 auto 40px auto;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .login-box{
        .login-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            .phone_login{
                font-size: 16px;
                font-weight: bold;
                color: #111111;
            }
            .register{
                cursor: pointer;
                font-size: 12px;
                font-weight: 400;
                color: #0078EF;
            }
        }
    }
    .login-input{
        .agreement{
            margin-top: 32px;
        }
        .el-form-item{
            margin-bottom: 16px;
        }
        /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
            color: unset;
        }
         /deep/ .el-form-item__content{
            line-height: 0;
        }
        /deep/ .el-input{
            input{
                background: #F2F3F4;
            }
            input::-webkit-input-placeholder{
                font-size: 14px;
                font-weight: 400;
                color: #C9C9C9;
            }
        }
        .form-item-code {
            /deep/ .el-input__inner {
                border-right-color: #F2F3F4;
                &:focus {
                    border-right-color: #409eff;
                }
            }
        }
        .is-error {
            /deep/ .el-input__inner {
                border-right-color: #F56C6C;
            }
        }
        /deep/ .el-input-group__append{
            background: #F2F3F4;
            cursor: pointer;
            border-left: none;
            .send-code {
                border: none;
                color: #0078EF;
                &:hover {
                    background-color: transparent;
                }
                &:disabled {
                    color: #C9C9C9;
                }
            }
        }
        /deep/ .login-btn{
            width: 100%;
            height: 40px;
            background: #0078EF;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 20px;
        }
    }
    .forget-password {        
        margin-top: -10px;
        text-align: right;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
    }
    .forget-password span{
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue